import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function ForbiddenPage() {
  return (
    <>
      <SEOHead
        title="403 - Adgang nægtet | MC Transport"
        description="Du har ikke adgang til denne ressource. Kontakt MC Transport for assistance."
      />

      <section className="min-h-[70vh] flex items-center justify-center bg-zinc-950 text-white px-4 py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(220,38,38,0.15),transparent_70%)]" />

        <div className="max-w-xl mx-auto text-center relative z-10">
          <div className="inline-block px-4 py-1.5 rounded-full bg-amber-500/20 text-amber-400 font-mono text-xs font-bold uppercase tracking-wider mb-6 border border-amber-500/30">
            Fejlkode 403 · Adgang begrænset
          </div>

          <h1 className="font-condensed text-7xl sm:text-9xl font-extrabold uppercase tracking-tight text-white mb-4">
            403
          </h1>

          <h2 className="font-condensed text-2xl sm:text-3xl font-bold uppercase text-zinc-200 mb-4">
            Adgang nægtet
          </h2>

          <p className="text-zinc-400 text-sm sm:text-base leading-relaxed mb-8">
            Du har ikke de nødvendige rettigheder til at få vist dette område. Benyt genvejene herunder for at komme sikkert videre.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3.5 bg-red-600 hover:bg-red-700 text-white font-condensed text-lg font-bold uppercase tracking-wider rounded shadow transition-colors"
            >
              Gå til forsiden
            </Link>

            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3.5 bg-zinc-900 hover:bg-zinc-800 text-white font-condensed text-lg font-bold uppercase tracking-wider rounded border border-zinc-700 transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
